<template>
  <v-container class="col-12">
    <v-card class="pa-4">
      <v-row class="mx-0">
        <select-project
          v-model="project"
          class="report-base-filter"
          style="min-width: 200px"
        ></select-project>
        <v-select
          :items="dateRangeList"
          :value="dateRangeList[0]"
          label="Period"
          v-on:change="changeTimePeriod"
          hide-details
          class="report-base-filter"
          style="min-width: 200px"
        ></v-select>

        <date-picker
          v-model="from"
          label="Date From"
          style="max-width: 140px"
        />

        <date-picker
          v-model="to"
          label="Date To"
          style="max-width: 140px"
        />

        <v-btn color="info" v-on:click="search" class="mt-2" :disabled="loading" :loading="loading">Search</v-btn>
        <export :fields="exportFields" :data="filteredItems" />
      </v-row>
    </v-card>


    <v-card class="col-12 pt-4 pb-4 px-0 mt-4">
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="filteredItems"
        sort-by="created"
        sort-desc
        :height="`calc(100vh - 165px - ${!options.pagination ? 0 : 60}px - ${!options.padding ? 0 : options.padding}px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
        fixed-header
        calculate-widths
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :hide-default-footer="!options.pagination"
        :items-per-page="options.perpage || -1"
        :footer-props="{'items-per-page-options': options.perpage ? [30, 60, 90] : [-1]}"
        :class="{nowrap, 'table-size-fixed': table_size_fixed, 'report-dt': true}"
        :expanded.sync="expanded"
        show-expand
        item-key="index"
        style="z-index: 0; position: relative; width: 100%"
      >
        <template v-slot:expanded-item="{ headers , item }">
          <td :colspan="headers.length" class="pa-0 acceptance_rate_chart">
            <default-chart :index="item.index" :alias="item.paysystem + item.paymethod + item.index" title="" :data="chartData" :series="item.details" :options="{}" />
          </td>

        </template>
        <template v-slot:item.row_num="{ index }">
          <span>{{ index + 1 }}</span>
        </template>
        <template v-slot:body.prepend>
          <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
            <td
              v-for="header in headers"
              :key="header.text"
            >
              <v-select
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
                hide-details
                dense
                small
                multiple
                clearable
                persistent-hint
                return-object
                single-line
                class="data-table-finance-filter-select"
                :items="columnValueList(header.value)"
                :style="{width: (filters[header.value] || {width: false}).width}"
                v-model="filters[header.value].data"
              ></v-select>
              <v-text-field
                class="data-table-finance-filter-textfield"
                v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
                v-model="filters[header.value].data"
                :style="{width: (filters[header.value] || {width: false}).width}"
                hide-details
              ></v-text-field>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<style lang="scss" scoped>
  @import '@/assets/table/report-table.scss';

  ::v-deep.acceptance_rate_chart > .v-card {
    border-radius: 0 !important;
  }
</style>

<script>
  import moment from 'moment'
  import { find, get, map, filter, concat, toString } from 'lodash'
  import { API } from '@/utils/api'
  import { duplicatesFlags } from '@/utils/helper'
  import SelectProject from '@/components/core/SelectProject/SelectProject.vue'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    name: 'AcceptanceRate',
    props: { title: {}, headers: {}, filters: {}, url: {}, defaultParams: { default: () => ({}) }, nowrap: { default: true }, table_size_fixed: { default: false }, options: { default: () => ({}) } },

    components: {
      SelectProject,
      DatePicker,
      Export: () => import('@/components/helper/Export'),
      DefaultChart: () => import('@/components/dashboard/DefaultChart'),
    },

    data: () => ({
      chartData: {
        colors: [ '#FF6384', '#42A5F5', '#26A69A' ],
        labels: [ 'Rate', 'Completed', 'Pending' ],
        ykeys: [ 'acceptance_rate', 'completed', 'pending' ],
        xkey: 'date',
      },
      totalItems: -1,
      tableOptions: {},
      project: null,
      loading: false,
      totalRow: false,
      country: '',
      totalRows: false,
      items: [],
      rule: '(deposit - withdraw - bonus) * 0.1',
      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),
      dateRangeList,
      accountType: [ 'casino', 'sport' ],
      expanded: [],
    }),

    computed: {
      exportFields: function () {
        return map(this.headers, 'value')
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval((get(d, f) || '0').toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || ((this.filters[f].data.includes((get(d, f) || '')) && toString((get(d, f) || '')).length > 0)
                || (this.filters[f].data.includes(true) && ((get(d, f) || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((get(d, f) || '').toString().toLowerCase()).length == 0)
                || (typeof get(d, f) != 'boolean' && ((get(d, f) || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    mounted () {
      this.headers.push({ text: '', value: 'data-table-expand', 'class': 'nowrap' })
    },

    watch: {
      tableOptions: {
        handler () {
          if (this.options.pagination) {
            this.search()
          }
        },
        deep: true,
      },
    },

    methods: {
      duplicatesFlags,

      changeTimePeriod: function (value) {
        this.from = value.from
        this.to = value.to
      },

      getTotalHeaderText: function (alias) {
        return find(this.headers, (o) => o.value === alias, {}).text
      },

      search: function () {
        this.loading = true
        try {
          if (this.options.accountType) {
            this.defaultParams.account_type = this.accountType
          }

          API.call(this.url, {
            from: this.from,
            to: this.to,
            country: this.country,
            rule: this.rule,
            ...this.defaultParams,
            ...this.tableOptions
          }, null, this.project).then(resp => {

            this.items = get(resp, 'data', [])
            if (get(resp, 'pagination', false)) {
              this.totalItems = resp.pagination.total
            }
            if (get(resp, 'totalRow', false)) {
              this.totalRow = resp.totalRow
            }
            if (get(resp, 'totalRows', false)) {
              this.totalRows = resp.totalRows
            }

            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },

      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      columnValueList (val) {
        return this.items.map(d => d[val])
      }
    },
  }
</script>
